import { deferredResourceQueryOptions } from "@/utils/deferred-resource-query";
import { orpc } from "@/utils/orpc.client";

export function getReleaseTrackVideosQueryOptions(id: string) {
  return deferredResourceQueryOptions(
    orpc.music.getTrackVideosResource.queryOptions({
      input: { entity: "release", id },
    }),
  );
}
